import React, { useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import PageHeader from "../components/ui/PageHeader";
import CompanyList from "../components/companies/CompanyList";
import CompanyForm from "../components/companies/CompanyForm";
import CompanyDetail from "../components/companies/CompanyDetail";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";

const CompaniesPage = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const [showForm, setShowForm] = useState(false);
  const [editingCompany, setEditingCompany] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("new") === "true") {
      setShowForm(true);
    }
  }, []);
  const handleView = (company) => {
    navigate(`/companies/${company.id}`);
  };

  const handleEdit = (company) => {
    setEditingCompany(company);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingCompany(null);
    setRefreshKey((k) => k + 1);
  };

  if (companyId) {
    return <CompanyDetail companyId={companyId} onEdit={handleEdit} />;
  }

  return (
    <Box>
      <PageHeader
        title="Empresas"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingCompany(null);
              setShowForm(true);
            }}
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: 'none',
              '&:hover': {
                boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
                filter: 'brightness(1.05)',
              },
            }}
          >
            Nueva Empresa
          </Button>
        }
      />
      <CompanyList key={refreshKey} onView={handleView} onEdit={handleEdit} />

      <Dialog
        key={editingCompany?.id || "new"}
        open={showForm}
        onClose={() => {
          setShowForm(false);
          setEditingCompany(null);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <CompanyForm
            company={editingCompany}
            onSave={handleSave}
            onCancel={() => {
              setShowForm(false);
              setEditingCompany(null);
            }}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default CompaniesPage;